import { getApiClient } from '@treneo/infrastructure/api';

import { CoursesApi } from './courses.api';
import { DesktopsApi } from './desktops.api';

export * from './courses.api';
export * from './desktops.api';

export const coursesApi = new CoursesApi(getApiClient());
export const desktopsApi = new DesktopsApi(getApiClient());
